import React from 'react';
import './CSS/Shimbun3.css';

function Shimbun3() {
  return (
    <main className="history-page">
      <div className="history-timeline-line"></div>

      <div className="history-topbar">
        History · Aikido in Thailand · B.E. 2504 – Present
      </div>

      {/* HERO */}
      <section className="history-hero">
        <div className="history-hero-bg-circles"></div>
        <div className="history-hero-grid"></div>
        <div className="history-hero-kanji">合気道</div>

        <div className="history-hero-inner">
          <div className="history-hero-kicker">
            Special Feature · Research-Based Article
          </div>

          <h1 className="history-hero-title">
            ไอคิโดในแผ่นดินไทย
            <em>จากนักข่าวอเมริกัน สู่รากลึกกว่าครึ่งศตวรรษ</em>
          </h1>

          <p className="history-hero-sub">
            ย้อนรอยเส้นทางของศิลปะป้องกันตัวแห่งสันติจากญี่ปุ่น
            ที่เดินทางข้ามทะเลมาหยั่งรากในสังคมไทย
            จากห้องฝึกเล็ก ๆ สู่สมาคม โรงเรียน มหาวิทยาลัย หน่วยงานราชการ
            และชีวิตของผู้ฝึกหลายรุ่น
          </p>

          <div className="history-hero-scroll">เลื่อนอ่าน</div>
        </div>
      </section>

      {/* INTRO */}
      <section className="history-intro">
        <p>
          ปี พ.ศ. 2504 แทบไม่มีใครในประเทศไทยรู้จักคำว่า “ไอคิโด”
          จนกระทั่งนักข่าวชาวอเมริกันคนหนึ่งเดินเข้าไปยังวิทยาลัยพลศึกษา
          สนามกีฬาแห่งชาติ พร้อมกับศิลปะการต่อสู้ที่ไม่เน้นการแข่งขัน
          ไม่เน้นการเอาชนะ และไม่ตั้งอยู่บนแนวคิดของผู้แพ้หรือผู้ชนะ
          วันนั้นกลายเป็นจุดเริ่มต้นของประวัติศาสตร์ไอคิโดในแผ่นดินไทย
        </p>
      </section>

      {/* CHAPTER 1 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">พ.ศ. 2504</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 1 · จุดเริ่มต้น</div>
              <h2 className="history-ch-title">
                ชายชาวอเมริกันและประตูบานแรกของไอคิโด
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              เรื่องราวเริ่มต้นจาก <strong>มิสเตอร์ ไวท์ ซิโดนี</strong>{' '}
              (Mr. White Sydony) นักข่าวชาวอเมริกันผู้ไม่ได้เดินทางมาไทย
              เพื่อรายงานข่าวเพียงอย่างเดียว แต่ยังนำศิลปะการต่อสู้ที่เขาหลงใหล
              ติดตัวมาด้วย เขาเปิดคลาสไอคิโดขึ้นที่วิทยาลัยพลศึกษา
              สนามกีฬาแห่งชาติ ในปี พ.ศ. 2504
              ซึ่งนับเป็นคลาสไอคิโดชุดแรกของประเทศไทย
            </p>

            <p>
              อย่างไรก็ตาม ซิโดนีรู้ดีว่าเขาเพียงคนเดียวไม่อาจวางรากฐานของวิชานี้ได้อย่างมั่นคง
              เขาจึงติดต่อประสานงานกับ <strong>อาจารย์ทามูระ</strong>{' '}
              ครูไอคิโดจากมหาวิทยาลัยในกรุงโตเกียว
              จนนำไปสู่การเดินทางของอาจารย์ชาวญี่ปุ่นหลายท่าน
              ที่ทยอยเข้ามาสอนในเมืองไทยอย่างต่อเนื่องตลอดหลายทศวรรษ
            </p>

            <div className="history-pq">
              <p>
                “ไม่มีการแข่งขัน ไม่มีแพ้ ไม่มีชนะ —
                นี่คือสิ่งที่ทำให้ไอคิโดแตกต่างจากศิลปะการต่อสู้หลายแขนง
                ที่คนไทยคุ้นเคยในยุคนั้น”
              </p>
              <cite>จากการสัมภาษณ์ผู้เชี่ยวชาญไอคิโดในประเทศไทย</cite>
            </div>

            <p>
              ในช่วงปี พ.ศ. 2505–2511 การสอนดำเนินไปที่วิทยาลัยพลศึกษาเป็นหลัก
              ก่อนจะย้ายไปยังสถานที่ต่าง ๆ ในกรุงเทพฯ เช่น กองปราบปรามสามยอด
              สถานฝึกบูโดกัน ถนนเยาวราช และคณะวิทยาศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย
            </p>

            <p>
              ต่อมาในปี พ.ศ. 2511 ไอคิโดได้รับโอกาสสำคัญในการแสดงการฝึก
              <strong> หน้าพระที่นั่ง ณ สวนอัมพร</strong>
              เหตุการณ์นี้ช่วยให้ไอคิโดก้าวออกจากห้องฝึกเล็ก ๆ
              สู่สายตาของสาธารณชน และเริ่มเป็นที่รู้จักมากขึ้นในสังคมไทย
            </p>
          </div>
        </div>
      </section>

      {/* CHAPTER 2 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">พ.ศ. 2513–2518</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 2 · การก่อร่าง</div>
              <h2 className="history-ch-title">
                จากห้องฝึกของคาวาซากิ สู่การก่อตั้งสมาคม
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              จุดเปลี่ยนครั้งสำคัญเกิดขึ้นในปี พ.ศ. 2513 เมื่อ{' '}
              <strong>บริษัทคาวาซากิ ประเทศไทย</strong>
              ให้การสนับสนุนสถานที่ฝึกบนชั้น 4 ของอาคารตรงข้ามไปรษณีย์บางรัก
              โดยใช้ชื่อว่า <strong>“เรนบูกัง”</strong>
              ชื่อนี้กลายเป็นหนึ่งในชื่อสำคัญของประวัติศาสตร์ไอคิโดไทย
              และยังคงมีความหมายต่อผู้ฝึกมาจนถึงปัจจุบัน
            </p>

            <p>
              ห้าปีต่อมา อาจารย์ <strong>ประพันธ์ จิตตะปุตตะ</strong>
              เป็นหัวหน้าคณะในการจัดตั้งสมาคม และในวันที่{' '}
              <strong>5 สิงหาคม พ.ศ. 2518</strong>
              สมาคมไอคิโดประเทศไทยได้รับการจดทะเบียนอย่างเป็นทางการ
              โดยมี <strong>อาจารย์โมโตฮิโร ฟูกากูซา</strong>
              ชาวญี่ปุ่น ขึ้นดำรงตำแหน่งนายกสมาคมคนแรก
              และท่านได้ทำหน้าที่นี้ต่อเนื่องยาวนานกว่า 30 ปี
            </p>

            <div className="history-fact-box">
              <h4>ลำดับเหตุการณ์สำคัญ พ.ศ. 2518–2541</h4>
              <ul>
                <li>5 สิงหาคม 2518 — จดทะเบียนสมาคมไอคิโดประเทศไทยอย่างเป็นทางการ</li>
                <li>1 มกราคม 2525 — ย้ายสถานที่ฝึกไปยังสมาคม Y.M.C.A. ถนนสาธร</li>
                <li>3 มกราคม 2525 — ก่อตั้งชมรมไอคิโดศูนย์เยาวชน กทม. ไทย-ญี่ปุ่น</li>
                <li>3 เมษายน 2525 — พระบาทสมเด็จพระเจ้าอยู่หัว ร.9 เสด็จเยี่ยมชมศูนย์เยาวชน</li>
                <li>9 มิถุนายน 2531 — จดทะเบียนย้ายสำนักงานไปที่ถนนพัฒนาการ</li>
                <li>26 พฤศจิกายน 2541 — ย้ายมาที่ถนนสุขุมวิท ซอย 67-69 ซึ่งเป็นที่ตั้งสำคัญในยุคปัจจุบัน</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CHAPTER 3 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">สายอาจารย์</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 3 · ครูผู้ข้ามน้ำ</div>
              <h2 className="history-ch-title">
                15 อาจารย์ญี่ปุ่นผู้วางรากฐาน
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              หนึ่งในเรื่องที่น่าทึ่งที่สุดของไอคิโดในประเทศไทย
              คือการที่สำนักงานใหญ่ในกรุงโตเกียวส่งอาจารย์ชาวญี่ปุ่น
              เข้ามาสอนอย่างต่อเนื่อง รวมทั้งสิ้น 15 ท่านในช่วงเวลาหลายทศวรรษ
              บางท่านมาเพียงช่วงสั้น ๆ บางท่านกลับมาหลายครั้ง
              และบางท่านได้อยู่สอนจนกลายเป็นส่วนหนึ่งของประวัติศาสตร์ไอคิโดไทย
            </p>

            <div className="history-teacher-grid">
              <div className="history-teacher-card">
                <div className="history-t-name">โมโตฮิโร ฟูกากูซา</div>
                <div className="history-t-period">
                  พ.ศ. 2507 – ปัจจุบัน · 7 ดัน · นายกสมาคม
                </div>
              </div>

              <div className="history-teacher-card">
                <div className="history-t-name">ซาดาโอะ นิชิมูระ</div>
                <div className="history-t-period">
                  พ.ศ. 2513, 2525 – ปัจจุบัน · 5 ดัน
                </div>
              </div>

              <div className="history-teacher-card">
                <div className="history-t-name">เคนทาโร บาบะ</div>
                <div className="history-t-period">
                  พ.ศ. 2513 – ปัจจุบัน · 5 ดัน
                </div>
              </div>

              <div className="history-teacher-card">
                <div className="history-t-name">เทซูโนบุ ทานิกาวะ</div>
                <div className="history-t-period">พ.ศ. 2523 – ปัจจุบัน</div>
              </div>

              <div className="history-teacher-card">
                <div className="history-t-name">ชิเกรุ ยามาดะ และ กูซูชิโต โอซาวะ</div>
                <div className="history-t-period">
                  พ.ศ. 2505–2506 · รุ่นบุกเบิก
                </div>
              </div>

              <div className="history-teacher-card">
                <div className="history-t-name">โชจิ นากาซาวะ และ คันจิ อิชิซาวะ</div>
                <div className="history-t-period">พ.ศ. 2508–2513</div>
              </div>
            </div>

            <p>
              ในบรรดาอาจารย์ทั้งหมด อาจารย์ฟูกากูซาถือเป็นบุคคลสำคัญที่สุดคนหนึ่ง
              ท่านเริ่มสอนตั้งแต่ พ.ศ. 2507 และไม่ได้เป็นเพียงครูผู้ถ่ายทอดเทคนิค
              แต่ยังเป็นผู้วางมาตรฐาน โครงสร้าง และจิตวิญญาณของไอคิโดในประเทศไทย
            </p>
          </div>
        </div>
      </section>

      {/* CHAPTER 4 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">สถานที่ฝึก</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 4 · แผนที่โดโจ</div>
              <h2 className="history-ch-title">
                จากเบาะเดียว สู่เครือข่ายโดโจทั่วประเทศ
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              สถานที่ฝึกไอคิโดจำนวนมากในประเทศไทยไม่ได้ตั้งอยู่ในยิมเอกชน
              หรือพื้นที่เชิงพาณิชย์ขนาดใหญ่ หากแต่ซ่อนตัวอยู่ในมหาวิทยาลัย
              ศูนย์เยาวชน และหน่วยงานราชการ นี่อาจเป็นเหตุผลหนึ่งที่หลายคน
              ไม่เคยรู้ว่าไอคิโดมีรากอยู่ในสังคมไทยมายาวนานเพียงใด
            </p>

            <div className="history-fact-box">
              <h4>สถานที่ฝึกสำคัญในประเทศไทย</h4>
              <ul>
                <li><strong>เรนบูกัง สมาคมไอคิโดประเทศไทย</strong> — ถนนสุขุมวิท ระหว่างซอย 67-69</li>
                <li><strong>ชมรมไอคิโดศูนย์เยาวชน กทม. ไทย-ญี่ปุ่น</strong> — ก่อตั้ง 3 มกราคม 2525</li>
                <li><strong>สมบูรณ์โฮม</strong> — ถนนพระราม 3 · ก่อตั้ง 2 กันยายน 2543</li>
                <li><strong>ชมรมไอคิโดมหาวิทยาลัยเชียงใหม่</strong> — ก่อตั้ง พ.ศ. 2529</li>
                <li><strong>ชมรมไอคิโด มจพ. พระนครเหนือ</strong> — ก่อตั้ง พ.ศ. 2540</li>
                <li><strong>มหาวิทยาลัยเกษตรศาสตร์</strong> — มีการสอนต่อเนื่องยาวนานโดย พ.อ. พิเศษ สมบูรณ์</li>
                <li><strong>มหาวิทยาลัยศรีนครินทรวิโรฒ</strong> — เคยจัดอยู่ในรายวิชา พล 177</li>
                <li><strong>จุฬาลงกรณ์มหาวิทยาลัย</strong> — เริ่มมีการสอนราว พ.ศ. 2514</li>
              </ul>
            </div>

            <div className="history-pq">
              <p>
                “คนที่เปิดสอนไอคิโดจำนวนมากไม่ได้เริ่มจากคำถามเรื่องรายได้
                แต่เริ่มจากความเชื่อในคุณค่าของวิชา —
                เปิดด้วยใจ ไม่ใช่ด้วยกระเป๋า”
              </p>
              <cite>สรุปจากการสัมภาษณ์ผู้เชี่ยวชาญหลายท่าน</cite>
            </div>
          </div>
        </div>
      </section>

      {/* CHAPTER 5 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">ตัวเลข</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 5 · ตัวเลขที่บอกเล่า</div>
              <h2 className="history-ch-title">
                สี่ทศวรรษแรกของไอคิโดไทยในตัวเลข
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <div className="history-stat-row">
              <div className="history-stat-cell">
                <span className="history-num">2504</span>
                <span className="history-lbl">ปีที่เริ่มต้น</span>
              </div>

              <div className="history-stat-cell">
                <span className="history-num">15</span>
                <span className="history-lbl">อาจารย์ญี่ปุ่น</span>
              </div>

              <div className="history-stat-cell">
                <span className="history-num">76</span>
                <span className="history-lbl">สมาชิกสายดำใน 40 ปีแรก</span>
              </div>

              <div className="history-stat-cell">
                <span className="history-num">6</span>
                <span className="history-lbl">ตำราภาษาไทย</span>
              </div>
            </div>

            <p>
              จำนวน 76 สายดำในช่วงสี่สิบปีแรกอาจฟังดูไม่มาก
              แต่ตัวเลขนี้สะท้อนธรรมชาติของไอคิโดอย่างชัดเจน
              เพราะแต่ละคนต้องผ่านการฝึกอย่างยาวนาน การสอบที่เข้มงวด
              และมาตรฐานที่เชื่อมโยงกับสำนักงานใหญ่ไอคิโดโลกในกรุงโตเกียว
            </p>

            <p>
              ไอคิโดในไทยไม่เคยเป็นวิชาแบบ “แมสมาร์เก็ต”
              และอาจไม่จำเป็นต้องเป็นเช่นนั้น เพราะไอคิโดไม่มีการแข่งขัน
              ไม่มีเหรียญทอง ไม่มีเวทีถ่ายทอดสด สิ่งที่มีคือความเงียบของโดโจ
              เสียงเบาะ การฝึกซ้ำ และการขัดเกลาตัวเองอย่างต่อเนื่อง
            </p>
          </div>
        </div>
      </section>

      {/* CHAPTER 6 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">ตำรา</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 6 · มรดกทางความรู้</div>
              <h2 className="history-ch-title">
                หกเล่มที่บันทึกวิชาไว้เป็นภาษาไทย
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              ในวงการที่มีผู้ฝึกไม่มากนัก ตำราภาษาไทยเกี่ยวกับไอคิโดมีเพียงหกเล่ม
              ส่วนใหญ่รวบรวมโดยนักวิชาการในสถาบันการศึกษา
              และล้วนเป็นการเรียบเรียงจากประสบการณ์ตรงในประเทศไทย
              ไม่ใช่เพียงการแปลจากตำราต่างประเทศ
            </p>

            <div className="history-fact-box">
              <h4>ตำราไอคิโดภาษาไทยทั้งหกเล่ม</h4>
              <ul>
                <li><strong>“ไอคิโดเบื้องต้น”</strong> — ผศ.ดร.นำชัย เลวัลย์ พ.ศ. 2531</li>
                <li><strong>“ศิลปะการป้องกันตัว”</strong> — รศ.สุนทร แมนสงวน พ.ศ. 2533</li>
                <li><strong>“ไอคิโด”</strong> — รศ.ดร.ประพัฒน์ และ อ.ยุวดี ลักษณพิสุทธิ์ พ.ศ. 2537</li>
                <li><strong>เอกสารฉลองครบรอบ 30 ปี นายกสมาคม</strong> — สมาคมไอคิโดฯ พ.ศ. 2537</li>
                <li><strong>“เอกสารคำสอนวิชาไอคิโด”</strong> — รศ.ปรีชา ตันจริยานนท์ พ.ศ. 2541</li>
                <li><strong>คู่มือฉลองครบรอบ 40 ปี สมาคม</strong> — สมาคมไอคิโดฯ พ.ศ. 2546</li>
              </ul>
            </div>

            <p>
              สิ่งที่น่าสนใจคือ ความรู้เหล่านี้ไม่ได้เป็นเพียงเสียงสะท้อนจากต่างประเทศ
              แต่เป็นเสียงของครูไทย ผู้ฝึกไทย และสถาบันไทย
              ที่พยายามบันทึกประสบการณ์ของตนเองให้เป็นมรดกทางความรู้
            </p>
          </div>
        </div>
      </section>

      {/* CHAPTER 7 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">บทบาท</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 7 · เกินกว่าโดโจ</div>
              <h2 className="history-ch-title">
                เมื่อไอคิโดก้าวออกสู่สังคม
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              ไอคิโดไม่ได้จำกัดตัวเองอยู่เพียงในโดโจ
              หน่วยงานราชการ ตำรวจ ทหาร และองค์กรเพื่อสังคมหลายแห่ง
              เคยนำหลักการของไอคิโดไปใช้ในโครงการพัฒนาคน
              การควบคุมสถานการณ์ และการลดความรุนแรง
            </p>

            <div className="history-fact-box">
              <h4>ตัวอย่างโครงการที่ใช้ไอคิโดเพื่อสังคม</h4>
              <ul>
                <li><strong>โครงการแต่งไม้งามด้วยหนามคม</strong> — กรมพลศึกษา และสภาสตรีแห่งชาติ</li>
                <li><strong>โครงการฝึกชุดชิงตัวประกัน</strong> — ตำรวจภูธรจังหวัดลำปาง</li>
                <li><strong>โครงการฝึกยุทธวิธีจับกุม</strong> — สน.บางเขน</li>
                <li><strong>โครงการฝึกสตรีแกนนำชุมชน</strong> — สน.เมืองลำปาง</li>
                <li><strong>โครงการไอคิโด โรงเรียนเตรียมทหาร</strong> — ฝึกทักษะป้องกันตัวสำหรับนักเรียนทหาร</li>
                <li><strong>โครงการฝึกบุคลากรรับมือผู้ป่วยภาวะวิกฤต</strong> — โรงพยาบาลด้านนิติจิตเวช</li>
              </ul>
            </div>

            <div className="history-pq">
              <p>
                “ไอคิโดสอนให้มีทางเลือก —
                จบสถานการณ์โดยลดการบาดเจ็บให้มากที่สุด
                นี่คือเหตุผลที่หน่วยงานด้านความปลอดภัยให้ความสนใจ”
              </p>
              <cite>สรุปจากเหตุผลการนำไอคิโดเข้าโครงการฝึกอบรม</cite>
            </div>
          </div>
        </div>
      </section>

      {/* CHAPTER 8 */}
      <section className="history-chapter">
        <div className="history-chapter-wrap">
          <div className="history-ch-header">
            <div className="history-ch-year">ปรัชญา</div>

            <div className="history-ch-titles">
              <div className="history-ch-label">บทที่ 8 · หัวใจของวิชา</div>
              <h2 className="history-ch-title">
                ทำไมไอคิโดจึงไม่มีการแข่งขัน
              </h2>
            </div>
          </div>

          <div className="history-ch-body">
            <p>
              คำถามที่ผู้คนมักถามเมื่อได้รู้จักไอคิโดคือ
              “ถ้าไม่มีการแข่งขัน แล้วจะรู้ได้อย่างไรว่าใครเก่งกว่าใคร”
              แต่สำหรับไอคิโด คำถามนี้อาจตั้งอยู่บนกรอบคิดคนละแบบกับตัววิชา
            </p>

            <p>
              ปรมาจารย์มอริเฮอิ อูเอชิบา ผู้ก่อตั้งไอคิโด
              ผ่านการฝึกศิลปะการต่อสู้มาหลายแขนง
              แต่ท้ายที่สุดท่านมองว่าการต่อสู้ที่แท้จริง
              ไม่ใช่การเอาชนะผู้อื่น หากคือการเอาชนะความโกรธ
              ความกลัว และความอยากชนะภายในตนเอง
            </p>

            <div className="history-pq">
              <p>
                “ไอคิโดไม่ใช่การต่อสู้เพื่อทำลายคู่ตรงข้าม
                แต่คือการสลายความขัดแย้งก่อนที่มันจะกลายเป็นการทำร้ายกัน”
              </p>
              <cite>จากปรัชญาพื้นฐานของไอคิโด</cite>
            </div>

            <p>
              นี่คือเหตุผลที่ครูไอคิโดจำนวนมากในประเทศไทยเห็นตรงกันว่า
              วิชานี้ไม่ควรถูกลดทอนให้กลายเป็นเพียงกีฬาแข่งขัน
              เพราะการแข่งขันสร้างผู้แพ้และผู้ชนะ
              ขณะที่แก่นของไอคิโดมุ่งไปสู่การอยู่ร่วมกัน
              การควบคุมตนเอง และการเห็นผู้อื่นเป็นเพื่อนร่วมทาง
            </p>
          </div>
        </div>
      </section>

      {/* CLOSING */}
      <section className="history-closing">
        <h2>
          “ต้องมีกรอบที่แข็งแรงก่อน
          <br />
          จึงจะก้าวข้ามกรอบนั้นได้อย่างอิสระ”
        </h2>

        <p>
          ไอคิโดในแผ่นดินไทยยังคงเดินหน้าต่อไปอย่างเงียบเชียบ
          ไม่หวือหวา ไม่เร้าใจแบบกีฬาบนเวทีใหญ่
          แต่มั่นคงเหมือนต้นไม้ที่รากลึกกว่าที่ตามองเห็น
          สิ่งที่เริ่มจากนักข่าวอเมริกันในปี พ.ศ. 2504
          ถูกส่งต่อผ่านอาจารย์ญี่ปุ่น ครูไทย และผู้ฝึกหลายรุ่น
          จนกลายเป็นส่วนหนึ่งของประวัติศาสตร์ศิลปะการต่อสู้ในประเทศไทย
        </p>

        <div className="history-closing-ornament">合気道</div>
      </section>

      <footer className="history-footer">
        <strong>เรียบเรียงจากวิทยานิพนธ์:</strong> ฉัตยมงคล ชาแทน. (2547).
        พัฒนาการไอคิโดในประเทศไทย. กศ.ม. พลศึกษา.
        มหาวิทยาลัยศรีนครินทรวิโรฒ.
      </footer>
    </main>
  );
}

export default Shimbun3;
